export const resources = {
  en: {
    translation: {
      home: "Home",
      day1: "Day 1", // Title for Day 1
      day2: "Day 2",
      d1: "D-1",
      d2: "D-2",
      activities: "Activities",
      register: "Register Now",
      japanese: "日本語　",
      dept: "Department Of Foreign Languages",
      english: "English",
      inCollaborationWith: "In Collaboration With",
      jetaa: "JETAA",
      clair: "CLAIR",
      jal: "JAPAN AIRLINES",
      jetaaIndia: "JETAA INDIA",
      november: "NOVEMBER",
      date: "7TH AND 8TH",
      eventInfo:
        "Join us for an exciting event filled with insights, networking, and collaboration. Be part of the journey on the 7th and 8th of November, where innovation meets culture.",
      faculty: "FACULTY", // Add translation key for Faculty
      countdownTimer: "COUNTDOWN TIMER", // Add translation key for Countdown Timer
      deanInternationalRelations: "DEPARTMENT HEAD",
      deanInternationalRelations1: "DEAN INTERNATIONAL RELATIONS",
      deanCardName: "Dr KISHOR BABU",
      deanCardDesc: "DEAN INTERNATIONAL RELATIONS & MHS, CONVENER OF THE FEST",
      deanCardName1: "JAMINDAR BUDDIGA",
      deanCardDesc1:
        "HEAD OF DEPARTMENT OF FOREIGN LANGUAGES, CO-CONVENER OF THE FEST",
      facultyCard1Name: "MD SALMAN",
      facultyCard1Desc: "Japanese Faculty, Chief Coordinator of Ohayou Japan ",
      facultyCard2Name: "RAGINI SHARMA",
      facultyCard2Desc: "Japanese Faculty",
      facultyCard3Name: "IRFAN MOHAMMED",
      facultyCard3Desc: "Japanese Faculty",
      facultyCard4Name: "ANAND RAJ",
      facultyCard4Desc: "Japanese Faculty",
      footerTitle: "Designed & Developed by Adnan and Jayaram",
      footerNameAdnan: "Adnan",
      footerNameJayaram: "Jayaram",
      footerRights: "© All rights reserved.",

      //----------------------------------------------------------------------------------------------------------------
      Day1: "DAY 1",
      timelineIntroduction:
        "An exciting start with cultural activities, workshops, and performances that set the tone for the event.",
      guestsArrivalTitle: "ARRIVAL OF GUESTS",
      inauguralTitle: "INAUGURAL",
      activitiesWorkshopsTitle: "ACTIVITIES & WORKSHOPS",
      venue1: "VENUE : NEW SEMINAR HALL",
      venue2: "VENUE: SAC HALL",

      lunchTitle: "LUNCH FOR GUESTS",
      afternoonWorkshopsTitle: "STAGE ACTIVITIES",
      stageActivitiesTitle: "GUESTS RETURN",
      guestsArrivalDesc:
        "Guests arrive at the venue, and preparations for the event begin. Attendees are welcomed and seated during this period.",
      inauguralDesc:
        "The official inauguration ceremony of the event takes place. Key speakers or hosts introduce the event and its purpose.",
      activitiesDesc:
        "Interactive sessions or workshops begin for participants. Various activities designed to engage the audience are conducted.",
      lunchDesc:
        "A break for lunch is provided to all attendees. Participants are encouraged to refresh and socialize during this time.",
      afternoonWorkshopsDesc:
        "Continuation of stage performances and prize distribution. Recognition is given to participants, followed by entertainment.",
      stageActivitiesDesc:
        "The event concludes with stage performances and prize distribution. Recognition is given to participants, followed by entertainment.",
      //-----
      arrivalTitle: "ARRIVAL OF GUESTS",
      arrivalDesc:
        "Guests arrive at the venue, and preparations for the event begin. Attendees are welcomed and seated during this period.",
      inauguralTitle: "INAUGURAL",
      inauguralDesc:
        "The official inauguration ceremony of the event takes place. Key speakers or hosts introduce the event and its purpose.",
      workshopTitle1: "ACTIVITIES & WORKSHOPS",
      workshopDesc1:
        "Interactive sessions or workshops begin for participants. Various activities designed to engage the audience are conducted.",
      lunchTitle: "LUNCH FOR GUESTS",
      lunchDesc:
        "A break for lunch is provided to all attendees. Participants are encouraged to refresh and socialize during this time.",
      workshopTitle2: "ACTIVITIES & WORKSHOPS",
      workshopDesc2:
        "Continuation of the workshops or activities from earlier sessions. Attendees participate in hands-on activities and group discussions.",
      stageTitle: "STAGE ACTIVITIES",
      stageDesc:
        "The event concludes with stage performances and prize distribution. Recognition is given to participants, followed by entertainment.",
      eventStartDesc:
        "An exciting start with cultural activities, workshops, and performances that set the tone for the event.", // Fade-in text

      //----------------------------------------------------------------------------------------------------------------

      Day2: "DAY 2",
      timelineIntroduction2:
        "An exciting start with cultural activities, workshops, and performances that set the tone for the event.",
      guestsArrivalDay2Title: "ARRIVAL OF GUESTS",
      discussionForumTitle: "DISCUSSION FORUM",
      lunchTitleDay2: "LUNCH FOR GUESTS",
      afternoonWorkshopsTitleDay2: "ACTIVITIES & WORKSHOPS",
      movieScreeningTitle: "MOVIE SCREENING",
      conclusionTitle: "CONCLUSION & SEND OFF",
      guestsArrivalDay2Desc:
        "Guests arrive and are seated for the second day of the event. Attendees prepare for the discussions and activities ahead.",
      discussionForumDesc:
        "A brief discussion or introductory session is conducted. This may set the tone for the day's workshops or activities.",
      lunchDescDay2:
        "A one-hour lunch break is provided. Participants can relax and socialize during this break.",
      afternoonWorkshopsDescDay2:
        "Workshops or activities resume for further participation. Attendees engage in interactive sessions and group work.",
      movieScreeningDesc:
        "A movie related to the event theme is screened for attendees. Participants enjoy the cinematic experience together.",
      conclusionDesc:
        "The event is officially concluded with closing remarks. Final farewells and acknowledgments are made to the participants.",

      //---------------------------------------------------------------------------------------------------------------------------------

      ACT: "ACTIVITY BOOTHS",
      STP: "STAGE PERFORMANCE",
      det: "View Details",
      yukataTitle: "Yukata Fashion Walk",
      karaokeTitle: "Karaoke Performance",
      folkTitle: "Inaugural Classic Dance",
      boysDanceTitle: "Boys Singing Performance",
      girlsDanceTitle: "Girls Singing Performance",
      judoTitle: "Soranbushi Group Performance",
      bhartanattyamTitle: "Dance Performance On Indian Music",
      speechTitle: "Speech Contest",
      prize: "Prize Distribution",
      //-------------------------

      knowTitle: "Knowledge Corner",
      chopstickTitle: "Chopstick Corner",
      calligraphyTitle: "Calligraphy",
      kanjiTitle: "Kanji Game Corner",
      origamiTitle: "Origami Corner",
      Art: "Art Corner",
      yukaPTitle: "Yukata Photo Booth",

      yukataDesc:
        "Experience the elegance of traditional Japanese fashion as participants showcase beautiful yukatas. Each ensemble brings the timeless charm of Japanese culture to life, blending traditional patterns with modern flair.",
      karaokeDesc:
        "A Karaoke Performance is a fun and interactive event where participants sing along to popular songs, with lyrics displayed on a screen. This activity is a popular form of entertainment in Japan and has become a global sensation. The performance allows participants to showcase their singing talent or simply have fun with friends in a relaxed and entertaining environment.",
      folkDesc:
        "Celebrate the opening ceremony with a traditional dance performance that captures the grace and rhythm of classic styles. This inaugural dance sets the tone for an evening of cultural richness and artistry.",
      boysDanceDesc:
        "A melodious treat awaits as the boys take the stage with a singing performance filled with joy and energy. This event celebrates talent, rhythm, and vocal creativity.",
      girlsDanceDesc:
        "Watch as the girls light up the stage with their beautiful voices in this engaging singing performance. Their songs will captivate the audience and create lasting memories.",
      judoDesc:
        "An invigorating group performance of the Soranbushi dance, known for its powerful movements and energetic rhythm. This traditional dance captures the spirit and strength of Japanese heritage.",
      bhartanattyamDesc:
        "A captivating dance set to vibrant Indian music, showcasing the beauty and diversity of Indian cultural expressions. Each move reflects the grace and tradition of Indian dance forms.",
      speechDesc:
        "A Speech Contest is a competitive event where participants deliver speeches, typically in Japanese, on various topics such as culture, international relations, or personal experiences. The contest helps showcase public speaking skills and knowledge of the Japanese language and culture. Participants are judged on the content of their speech, their delivery, and their ability to engage the audience.",
      prizeDesc:
        "The culmination of the event, where outstanding participants are recognized for their efforts and achievements. Each prize represents hard work, dedication, and a memorable contribution to the festivities.",
      //-----------------------------------
      knowDesc:
        "Dive into Japanese culture and history at the Knowledge Corner! This interactive exhibit offers fascinating facts, insights, and trivia about Japan’s rich heritage, art, and traditions.",
      chopstickDesc:
        "The Chopstick Skills event tests participants' dexterity and precision in handling chopsticks, a traditional Japanese utensil. Participants engage in various challenges, such as picking up small objects or transferring items from one bowl to another, to demonstrate their proficiency. This fun and engaging activity also educates attendees about Japanese dining customs and etiquette.",
      calligraphyDesc:
        "Calligraphy is the art of beautiful handwriting, and in Japan, it holds deep cultural significance. This event offers participants the opportunity to practice the ancient art of Japanese calligraphy, learning to write kanji and hiragana characters using traditional brushes and ink. It is both a meditative and artistic experience, connecting participants with the essence of Japanese culture.",
      origamiDesc:
        "Origami, the traditional Japanese art of paper folding, allows participants to create intricate shapes and figures using only a single sheet of paper. This event teaches the fundamental techniques of origami, encouraging creativity and patience. Participants can create everything from simple designs to complex structures, highlighting the beauty of this ancient art form.",
      kanjiDesc:
        "Put your Kanji skills to the test with fun games at the Kanji Game Corner! This activity challenges participants to identify and write Japanese characters, making learning fun and engaging.",
      ArtDesc:
        "Let your imagination soar at the Art Corner! Participants can express themselves through painting, drawing, and other creative activities inspired by Japanese art and culture.",
      yukaPDesc:
        "Capture the moment at the Yukata Photo Booth! Dress up in a traditional yukata and strike a pose for a memorable photo, taking a piece of Japanese culture with you as a keepsake.",
    },
  },
  jp: {
    translation: {
      home: "ホーム",
      day1: "1日目", // Title for Day 1 in Japanese
      day2: "2日目",
      d1: "1日目",
      d2: "2日目",
      activities: "活動",
      register: "今すぐ登録",
      japanese: "英語",
      english: "English",
      inCollaborationWith: "共同開催",
      deanInternationalRelations: "部長",
      deanInternationalRelations1: "国際関係学部長",
      deanCardName: "キショール・バブ博士",
      deanCardDesc: "国際関係およびMHS学部長, フェストの招集者",
      deanCardName1: "ジャミンダル・ブッガ",
      deanCardDesc1: "外国語学部部長, フェストの共同主催者",
      dept: "外国語学部",
      jetaa: "JETAA",
      clair: "CLAIR",
      jal: "日本航空",
      jetaaIndia: "JETAA インド",
      november: "11月",
      date: "7日と8日",
      eventInfo:
        "洞察、ネットワーキング、そしてコラボレーションに満ちたエキサイティングなイベントに参加してください。イノベーションと文化が交わる場所、11月7日と8日の旅にご参加ください。",
      faculty: "教授陣", // Translation for Faculty
      countdownTimer: "カウントダウンタイマー", // Translation for Countdown Timer
      facultyCard1Name: "エム ディー ・サルマン",
      facultyCard1Desc: "日本人教員, オハユージャパン チーフコーディネーター",
      facultyCard2Name: "ラーギニ・シャルマ",
      facultyCard2Desc: "日本人教員",
      facultyCard3Name: "イルファン・モハメド",
      facultyCard3Desc: "日本人教員",
      facultyCard4Name: "アナンド・ラージ",
      facultyCard4Desc: "日本人教員",
      footerTitle: "アドナンとジャヤラムによって設計および開発されました",
      footerNameAdnan: "アドナン",
      footerNameJayaram: "ジャヤラム",
      footerRights: "© 全著作権所有。",

      //-----------------------------------------------------------------------------------------------------------
      Day1: "1日目",
      timelineIntroduction:
        "文化活動、ワークショップ、パフォーマンスでイベントの幕開けを飾ります。",
      guestsArrivalTitle: "ゲストの到着",
      inauguralTitle: "開会式",
      activitiesWorkshopsTitle: "活動とワークショップ",
      lunchTitle: "昼食",
      afternoonWorkshopsTitle: "午後の活動とワークショップ",
      stageActivitiesTitle: "ステージ活動",
      venue1: " 会場：新セミナーホール",
      venue2: "会場：SACホール",
      guestsArrivalDesc:
        "ゲストが会場に到着し、イベントの準備が始まります。この期間中、参加者は歓迎され、席に案内されます。",
      inauguralDesc:
        "イベントの公式開会式が行われます。キースピーカーまたはホストがイベントとその目的を紹介します。",
      activitiesDesc:
        "参加者のためのインタラクティブなセッションまたはワークショップが始まります。観客を引き込むために設計された様々な活動が行われます。",
      lunchDesc:
        "参加者全員に昼食の時間が提供されます。参加者はこの時間にリフレッシュし、交流することが奨励されます。",
      afternoonWorkshopsDesc:
        "午前のセッションの続きとして、ワークショップやアクティビティが再開されます。参加者はハンズオン活動やグループディスカッションに参加します。",
      stageActivitiesDesc:
        "イベントはステージでのパフォーマンスと賞の授与で締めくくられます。参加者への感謝と共にエンターテインメントが提供されます。",

      //----------------------------------------------------------------------------------------------------------------

      Day2: "2日目",
      timelineIntroduction:
        "イベントの雰囲気を決める文化活動、ワークショップ、パフォーマンスでエキサイティングなスタートを切ります。",
      guestsArrivalDay2Title: "ゲストの到着",
      discussionForumTitle: "ディスカッションフォーラム",
      lunchTitleDay2: "ゲストの昼食",
      afternoonWorkshopsTitleDay2: "活動とワークショップ",
      movieScreeningTitle: "映画上映",
      conclusionTitle: "終了＆送別",

      // Descriptions for Day 2 Events in Japanese
      guestsArrivalDay2Desc:
        "ゲストが到着し、イベント2日目のために着席します。参加者はこれから始まるディスカッションと活動の準備をします。",
      discussionForumDesc:
        "短いディスカッションやイントロダクションセッションが行われます。これにより、その日のワークショップや活動のトーンが設定されます。",
      lunchDescDay2:
        "1時間の昼食休憩が提供されます。参加者はこの休憩中にリラックスして交流することができます。",
      afternoonWorkshopsDescDay2:
        "ワークショップやアクティビティが再開され、参加者はインタラクティブなセッションやグループ作業に参加します。",
      movieScreeningDesc:
        "イベントのテーマに関連する映画が上映されます。参加者は一緒に映画を楽しみます。",
      conclusionDesc:
        "イベントは公式に終了し、閉会の言葉で締めくくられます。最終的な別れと参加者への感謝が述べられます。",

      //----------
      ACT: "アクティビティブース",
      STP: "ステージパフォーマンス",
      yukataTitle: "浴衣ファッションウォーク",
      karaokeTitle: "カラオケパフォーマンス",
      folkTitle: "初演クラシックダンス",
      boysDanceTitle: "男の子歌唱パフォーマンス",
      girlsDanceTitle: "女の子歌唱パフォーマンス",
      judoTitle: "ソランブシグループパフォーマンス",
      bhartanattyamTitle: "インド音楽によるダンスパフォーマンス",
      speechTitle: "スピーチコンテスト",
      prize: "賞の授与",
      //-------------------------

      det: "詳細を見る",
      knowTitle: "知識コーナー",
      chopstickTitle: "箸コーナー",
      calligraphyTitle: "書道",
      kanjiTitle: "漢字ゲームコーナー",
      origamiTitle: "折り紙コーナー",
      Art: "アートコーナー",
      yukaPTitle: "浴衣フォトブース",

      yukataDesc:
        "参加者が美しい浴衣を披露し、伝統的な日本のファッションの優雅さを体験できます。それぞれの衣装は、日本文化の時代を超えた魅力を生き生きと表現し、伝統的なパターンと現代的なセンスが融合しています。",
      karaokeDesc:
        "カラオケパフォーマンスは、参加者が人気の曲に合わせて歌い、歌詞がスクリーンに表示される楽しくインタラクティブなイベントです。このアクティビティは日本で人気のあるエンターテインメント形式であり、世界中で広がっています。このパフォーマンスでは、参加者が歌の才能を披露したり、リラックスした楽しい環境で友達と楽しむことができます。",
      folkDesc:
        "オープニングセレモニーを祝うために、クラシックスタイルの優雅さとリズムを捉えた伝統的なダンスパフォーマンスが行われます。この初演のダンスは、文化の豊かさと芸術性にあふれる夜の雰囲気を作り出します。",
      boysDanceDesc:
        "男の子たちがエネルギーと喜びに満ちた歌唱パフォーマンスで舞台に登場します。このイベントは、才能、リズム、そしてボーカルの創造性を祝います。",
      girlsDanceDesc:
        "女の子たちがその美しい声で舞台を照らし、参加者の心をつかむ歌唱パフォーマンスをお楽しみください。彼女たちの歌は観客を魅了し、思い出に残る瞬間を作ります。",
      judoDesc:
        "力強い動きとエネルギッシュなリズムで知られるソランブシのダンスのグループパフォーマンスが行われます。この伝統的なダンスは、日本の遺産の精神と力強さを捉えています。",
      bhartanattyamDesc:
        "インド音楽に合わせた魅力的なダンスで、インドの文化的表現の美しさと多様性を紹介します。各動きは、インドのダンス形式の優雅さと伝統を反映しています。",
      speechDesc:
        "スピーチコンテストは、参加者が文化、国際関係、または個人的な経験など、さまざまなトピックに関してスピーチを行う競技イベントです。このコンテストは、公共のスピーキングスキルや日本語・日本文化の知識を示すのに役立ちます。参加者は、スピーチの内容、表現方法、および観客との関わり方が評価されます。",
      prizeDesc:
        "イベントのクライマックスで、優れた参加者がその努力と成果を認められます。それぞれの賞は、努力、献身、そしてお祝いに対する記憶に残る貢献を象徴しています。",
      //-----------------------------------
      knowDesc:
        "知識コーナーで日本の文化と歴史に触れてみましょう！このインタラクティブな展示では、日本の豊かな遺産、アート、伝統に関する興味深い事実や洞察を提供します。",
      chopstickDesc:
        "箸スキルイベントでは、伝統的な日本の器具である箸を扱う技術と精度をテストします。参加者は、小さな物を拾ったり、別のボウルから物を移したりするさまざまなチャレンジに参加し、技術を示します。この楽しく参加型のアクティビティでは、日本の食事の習慣やエチケットについても学ぶことができます。",
      calligraphyDesc:
        "書道は美しい手書きのアートであり、日本では深い文化的意義を持っています。このイベントでは、参加者が伝統的な筆とインクを使用して、漢字やひらがなの文字を書く古代のアートを練習する機会が提供されます。これは、参加者を日本文化の本質と結びつける、瞑想的でありながら芸術的な体験です。",
      origamiDesc:
        "折り紙は、日本の伝統的な紙折りのアートであり、参加者が一枚の紙だけを使用して複雑な形や図を作成します。このイベントでは、折り紙の基本的な技術を教え、創造性と忍耐を促します。参加者は、シンプルなデザインから複雑な構造まで、さまざまな作品を作成し、この古代のアート形式の美しさを強調します。",
      kanjiDesc:
        "漢字ゲームコーナーで楽しいゲームを通じて漢字のスキルを試してみましょう！このアクティビティでは、参加者が日本の文字を識別し、書くことに挑戦し、楽しく学べる体験を提供します。",
      ArtDesc:
        "アートコーナーで想像力を羽ばたかせましょう！参加者は、日本のアートと文化にインスパイアされた絵画、描画、その他の創造的なアクティビティを通じて自己表現ができます。",
      essayDesc:
        "浴衣フォトブースでその瞬間をキャッチしましょう！伝統的な浴衣を着てポーズを決め、思い出の一枚を撮影し、日本文化の一部を記念品として持ち帰ることができます。",
    },
  },
};
